import type { MemberEmailNotificationSettingsKey } from './types';

export const getMemberEmailNotificationSettingsKey =
  (): MemberEmailNotificationSettingsKey => [
    'suppliers',
    'memberEmailNotificationSettings',
  ];
